/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Track } from './Track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
} from './Track';

/**
 * 
 * @export
 * @interface TracksResponse
 */
export interface TracksResponse {
    /**
     * 
     * @type {Array<Track>}
     * @memberof TracksResponse
     */
    data?: Array<Track>;
}

/**
 * Check if a given object implements the TracksResponse interface.
 */
export function instanceOfTracksResponse(value: object): value is TracksResponse {
    let isInstance = true;

    return isInstance;
}

export function TracksResponseFromJSON(json: any): TracksResponse {
    return TracksResponseFromJSONTyped(json, false);
}

export function TracksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TracksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TrackFromJSON)),
    };
}

export function TracksResponseToJSON(value?: TracksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TrackToJSON)),
    };
}

